/* eslint-disable no-unused-vars */
import React, {
    useRef,
    useContext,
    useEffect,
} from 'react';
import { Box, Paper, Typography } from '@mui/material';
import useNebula from 'hooks/useNebula';

import PropTypes from 'prop-types';

import { styled } from '@mui/system';

import AppContext from '../AppContext';

const StackedBarWrapper = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    h3: {
        fontFamily: 'Lora',
        // textTransform: 'Capitalize',
        fontSize: '1em',
        color: theme.palette.green.main,
    },
}));

const StackedViz = styled(Box)(({ height }) => ({
    height: height || '300px',
    width: '100%',
    '&>div': {
        overflow: 'visible !important',
    },
    'svg[data-key="legend"]': {
        left: '0 !important',
        width: '100% !important',
    },
    '[data-component-key="legend"]': {
        display: 'none',
    },
}));

const StackedBar = ({
    options, title, percentageChecked, height,
}) => {
    const { qlikApp } = useContext(AppContext);

    const nebula = useNebula();

    const elementRefStacked = useRef();
    const stackedVizRef = useRef();

    // useEffect(async () => {
    //     if (!nebula) return;

    //     stackedVizRef.current = await nebula.render({
    //         element: elementRefStacked.current,
    //         type: 'stackedbar',
    //         fields: [
    //             {
    //                 qDef: {
    //                     qFieldDefs: [`${options.dimensionStack}`],
    //                     autoSort: false,
    //                 },
    //             },
    //             {
    //                 qDef: {
    //                     qFieldDefs: [`${options.dimension}`],
    //                     qSortCriterias: [
    //                         {
    //                             qSortByExpression: -1,
    //                             qExpression: {
    //                                 qv: percentageChecked ? options.measure : options.measureAlt,
    //                             },
    //                         },
    //                     ],
    //                     autoSort: false,
    //                 },
    //             },
    //             {
    //                 qDef: {
    //                     qDef: percentageChecked ? options.measure : options.measureAlt,
    //                 },

    //             },
    //         ],
    //     });
    // }, [nebula, percentageChecked]);

    useEffect(() => {
        let mounted = true;

        const renderChart = async () => {
            if (!nebula) return;

            const viz = await nebula.render({
                element: elementRefStacked.current,
                type: 'stackedbar',
                fields: [
                    {
                        qDef: {
                            qFieldDefs: [`${options.dimensionStack}`],
                            qSortCriterias: options.sortBy !== 'dimension' ? [
                                {
                                    qSortByExpression: options.sortDir === 'asc' ? -1 : 1,
                                    qExpression: {
                                        qv: percentageChecked ? options.measure : options.measureAlt,
                                    },
                                },
                            ] : [{
                                qSortByAscii: options.sortDir === 'asc' ? -1 : 1,
                            }],

                            autoSort: true,
                        },
                        qNullSuppression: true,
                    },
                    {
                        qDef: {
                            qFieldDefs: [`${options.dimension}`],
                            autoSort: true,
                        },
                        qNullSuppression: true,
                    },
                    {
                        qDef: {
                            qDef: percentageChecked ? options.measure : options.measureAlt,
                        },

                    },
                ],
            });

            if (mounted) {
                stackedVizRef.current = viz;
            } else if (viz) {
                // Unmount and destroy the chart instance when it is not needed anymore
                // viz.unmount();
                viz.destroy();
            }
        };

        renderChart();

        return () => {
            mounted = false;
            if (stackedVizRef.current) {
                // Unmount and destroy the chart instance when component is unmounted or before new chart is created
                // stackedVizRef.current.unmount();
                stackedVizRef.current.destroy();
            }
        };
    }, [nebula, percentageChecked]);

    return (
        <StackedBarWrapper>
            <Paper
              elevation={3}
              sx={{
                    width: '100%',
                    height: '100%',
                    padding: '10px',
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '10px',
                }}
            >
                <Typography variant="h3">{title}</Typography>
                <StackedViz id="stackedBarViz" ref={elementRefStacked} height={height} />
            </Paper>

        </StackedBarWrapper>
    );
};

StackedBar.propTypes = {
    options: PropTypes.object.isRequired,
    title: PropTypes.string,
    percentageChecked: PropTypes.bool,
    height: PropTypes.string,
};

StackedBar.defaultProps = {
    title: '',
    percentageChecked: true,
    height: '',
};

export default StackedBar;
